export default __webpack_public_path__ + "static/media/target.ccd48b08.svg";